module.exports = __webpack_public_path__ + "img/Isopaniṣad Radio Hour.be88e5ad.jpg";